const getBirthDatePartsFromPesel = (pesel: string) => {
  if (pesel.length < 6) {
    return null;
  }

  // Wyciągnij składniki daty z PESEL
  const yearPart = parseInt(pesel.substring(0, 2), 10);
  const monthPart = parseInt(pesel.substring(2, 4), 10);
  const day = parseInt(pesel.substring(4, 6), 10);

  // Określ stulecie na podstawie miesiąca
  let year: number;
  let month: number;

  if (monthPart >= 1 && monthPart <= 12) {
    // 1900-1999
    year = 1900 + yearPart;
    month = monthPart;
  } else if (monthPart >= 21 && monthPart <= 32) {
    // 2000-2099
    year = 2000 + yearPart;
    month = monthPart - 20;
  } else if (monthPart >= 81 && monthPart <= 92) {
    // 1800-1899
    year = 1800 + yearPart;
    month = monthPart - 80;
  } else if (monthPart >= 41 && monthPart <= 52) {
    // 2100-2199
    year = 2100 + yearPart;
    month = monthPart - 40;
  } else if (monthPart >= 61 && monthPart <= 72) {
    // 2200-2299
    year = 2200 + yearPart;
    month = monthPart - 60;
  } else {
    // Nieprawidłowy miesiąc
    return null;
  }

  // Walidacja daty
  const date = new Date(year, month - 1, day);

  // Sprawdź czy data jest prawidłowa (czy JavaScript nie skorygował nieprawidłowej daty)
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return { year, month, day };
};

/**
 * Waliduje PESEL (suma kontrolna + poprawność daty)
 * @param pesel - numer PESEL (tylko cyfry)
 * @returns true jeśli PESEL jest poprawny
 */
export const isValidPesel = (pesel: string): boolean => {
  if (pesel.length !== 11) {
    return false;
  }

  // Sprawdź sumę kontrolną
  const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const controlNumber = parseInt(pesel.substring(10, 11), 10);
  let sum = weight.reduce((acc, val, i) => {
    return acc + parseInt(pesel.substring(i, i + 1), 10) * val;
  }, 0);
  sum %= 10;

  if ((10 - sum) % 10 !== controlNumber) {
    return false;
  }

  return getBirthDatePartsFromPesel(pesel) !== null;
};

/**
 * Parsuje datę urodzenia z numeru PESEL
 * @param pesel - numer PESEL (może zawierać spacje lub myślniki)
 * @returns timestamp daty urodzenia lub null jeśli data w PESEL jest nieprawidłowa
 */
export const parseBirthDateFromPesel = (pesel: string): number | null => {
  if (!pesel) {
    return null;
  }

  // Usuń wszystkie znaki nie będące cyframi
  const cleanPesel = pesel.replace(/\D/g, "");

  const birthDateParts = getBirthDatePartsFromPesel(cleanPesel);

  if (!birthDateParts) {
    return null;
  }

  const { year, month, day } = birthDateParts;

  // Zwróć timestamp UTC (unikamy problemów ze strefami czasowymi)
  return Date.UTC(year, month - 1, day, 0, 0, 0, 0);
};
